// Logo click: go to the language-appropriate home (replaces the inline
// navigateBasedOnLanguage handler). Applies to every logo on the page — the
// header bar and the mobile menu overlay each have one.
document.querySelectorAll('[data-lang-home]').forEach((logo) => {
  logo.addEventListener('click', (event) => {
    event.preventDefault();
    const basePath = window.location.pathname.startsWith('/en') ? '/en' : '/';
    window.location.href = basePath;
  });
});
